"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carousel = _interopRequireDefault(require("../../../carousel"));
var _tabAnimation = require("./tab-animation");
var _classnames = _interopRequireDefault(require("classnames"));
require("../tabs.css");
var _excluded = ["onSlideChange"],
  _excluded2 = ["carouselProps", "children", "className", "onTabChange", "activeTab", "activeTabSliderClassName", "inactiveTabClassName", "parentId", "scrollable", "shouldFlattenTabListChildren", "setActiveTab"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A `TabList` should be placed as the immediate _and_ first descendant of a `Tabs` component. It should surround `Tab` components.
 *
 * **Note that only the props listed below should be modified, as this component is controlled by `Tabs`.**
 */
// eslint-disable-next-line max-statements
var TabList = function TabList(_ref) {
  var _ref$carouselProps = _ref.carouselProps,
    onSlideChange = _ref$carouselProps.onSlideChange,
    otherCarouselProps = _objectWithoutProperties(_ref$carouselProps, _excluded),
    children = _ref.children,
    className = _ref.className,
    onTabChange = _ref.onTabChange,
    activeTab = _ref.activeTab,
    activeTabSliderClassName = _ref.activeTabSliderClassName,
    inactiveTabClassName = _ref.inactiveTabClassName,
    parentId = _ref.parentId,
    scrollable = _ref.scrollable,
    shouldFlattenTabListChildren = _ref.shouldFlattenTabListChildren,
    setParentActiveTab = _ref.setActiveTab,
    otherProps = _objectWithoutProperties(_ref, _excluded2);
  // Prevent animation issues with separate jsx collections passed as children if enabled
  var tabListChildren = shouldFlattenTabListChildren ? children === null || children === void 0 ? void 0 : children.flat() : children;
  if (!shouldFlattenTabListChildren && (children === null || children === void 0 ? void 0 : children.length) !== (children === null || children === void 0 ? void 0 : children.flat().length)) {
    // eslint-disable-next-line no-console
    console.warn('Nested array detected in TabList children.  Consider enabling prop `shouldFlattenTabListChildren` to avoid animation issues.');
  }
  var $carousel = (0, _react.useRef)(null);
  var $tabContainer = (0, _react.useRef)(null);
  var $animatedSlider = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    animateSlider = _useState2[0],
    setAnimateSlider = _useState2[1];
  var _useState3 = (0, _react.useState)(activeTab ? activeTab : 0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentTab = _useState4[0],
    setCurrentTab = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    prevTab = _useState6[0],
    setPrevTab = _useState6[1];
  var tabElems = {};
  (0, _react.useEffect)(function () {
    if (prevTab !== null && animateSlider) {
      var slideAnimation = (0, _tabAnimation.animation)({
        prevTab: tabElems["$tab-".concat(prevTab)],
        currentTab: tabElems["$tab-".concat(currentTab)],
        animatedSlider: $animatedSlider.current,
        tabContainer: $tabContainer.current
      });
      var tempSlideAnimation = slideAnimation;
      slideAnimation.then(function () {
        if (tempSlideAnimation === slideAnimation) {
          setAnimateSlider(false);
        }
      });
    }
  }, [animateSlider]);
  var focusAndPreventScroll = function focusAndPreventScroll(tabElement) {
    tabElement.focus({
      preventScroll: true
    });
    // Prevent scroll on focus in browsers that don't support .focus({ preventScroll: true })
    if ($carousel.current) {
      $carousel.current.$slider.offsetParent.scrollLeft = 0;
    }
  };
  var handleSlideChange = function handleSlideChange(tabIndex) {
    if (tabElems["$tab-".concat(tabIndex)]) {
      focusAndPreventScroll(tabElems["$tab-".concat(tabIndex)]);
    }
    onSlideChange && onSlideChange(tabIndex);
  };
  var setActiveTab = function setActiveTab(tab, shouldSlide) {
    if (tab < 0 || tab >= tabListChildren.length || tab === currentTab) return;
    setPrevTab(currentTab);
    setCurrentTab(tab);
    if (shouldSlide && $carousel.current) {
      $carousel.current.setCurrentSlide(tab);
    }
    setParentActiveTab && setParentActiveTab(tab);
    focusAndPreventScroll(tabElems["$tab-".concat(tab)]);
  };
  var handleTabClick = function handleTabClick(tabIndex) {
    setActiveTab(tabIndex, false);
    onTabChange && onTabChange(tabIndex);
    if (tabIndex !== currentTab) {
      setAnimateSlider(true);
    }
  };
  var handleKeyDown = function handleKeyDown(_ref2) {
    var key = _ref2.key;
    if (key === 'ArrowLeft') {
      setActiveTab(currentTab - 1, true);
    } else if (key === 'ArrowRight') {
      setActiveTab(currentTab + 1, true);
    }
  };
  var childrenWithProps = _react["default"].Children.map(tabListChildren, function (child, idx) {
    if (!child) return null;
    var index = child.props.index || idx;
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      tabId: index,
      parentId: parentId,
      isActive: activeTab === index,
      inactiveTabClassName: inactiveTabClassName,
      onClick: function onClick() {
        return handleTabClick(index);
      },
      ref: function ref(el) {
        return tabElems["$tab-".concat(index)] = el;
      },
      sliderClassName: activeTabSliderClassName,
      innerLine: !animateSlider
    });
  });
  var renderNonScrollable = function renderNonScrollable() {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, childrenWithProps, animateSlider && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('sb-tabs--sliderDummy', _defineProperty({}, activeTabSliderClassName, activeTabSliderClassName)),
      ref: $animatedSlider
    }));
  };
  var renderScrollable = function renderScrollable() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "position-relative sb-tabs--carousel-container"
    }, /*#__PURE__*/_react["default"].createElement(_carousel["default"], _extends({
      inactiveSlideClassName: inactiveTabClassName,
      variableWidth: true
    }, otherCarouselProps, {
      onSlideChange: handleSlideChange,
      ref: $carousel
    }), childrenWithProps));
  };
  var getAriaOwns = function getAriaOwns() {
    var ariaOwns = '';
    _react["default"].Children.forEach(tabListChildren, function (child, idx) {
      if (child) {
        var index = child.props.index || idx;
        ariaOwns += "".concat(parentId, "-tab-").concat(index, " ");
      }
    });
    return ariaOwns.trim();
  };
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    "aria-owns": getAriaOwns(),
    className: (0, _classnames["default"])('position-relative flex', _defineProperty(_defineProperty({}, className, className), 'justify-around', !scrollable)),
    onKeyDown: handleKeyDown,
    ref: $tabContainer,
    role: "tablist"
  }, otherProps), scrollable ? renderScrollable() : renderNonScrollable(), animateSlider && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-tabs--sliderDummy', _defineProperty({}, activeTabSliderClassName, activeTabSliderClassName)),
    ref: $animatedSlider
  }));
};
TabList.displayName = 'TabList';
TabList.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Only `Tab` components should be passed in as children.
   */
  children: function children(props, propName, componentName) {
    var error;
    var prop = props[propName];
    _react["default"].Children.forEach(prop, function (child) {
      if (!child) return;
      if (child.type.displayName !== 'Tab') {
        error = new Error("`".concat(componentName, "` only accepts children of type `Tab`."));
      }
    });
    return error;
  },
  /**
   * This class is assigned to the surrounding container that wraps the child elements.
   */
  className: _propTypes["default"].string,
  /**
   * When the scrollable prop of the `Tabs` component is `true`, the `Tab`s are wrapped in a `Carousel`. This prop can be provided to supply custom behavior to the carousel component.
   *
   * Refer to the [Carousel](/components/carousel) documentation for more details on these props.
   */
  carouselProps: _propTypes["default"].object
} : {};
TabList.defaultProps = {
  carouselProps: {}
};
var _default = exports["default"] = TabList;